import * as React from "react";

function RocheIcon(props) {
  const { className, height, width } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 69 28"
    >
      <defs>
        <clipPath>
          <rect width="69" height="28" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip-roche)">
        <path
          data-name="Path 7097"
          d="M13.758,0h-2.4L6.5-7.512H4.371V0H2.449V-16.535H7.125a5.618,5.618,0,0,1,3.721,1.143,3.922,3.922,0,0,1,1.365,3.182,4.048,4.048,0,0,1-1,2.689,5.009,5.009,0,0,1-2.742,1.6ZM4.371-9.187H6.8a3.631,3.631,0,0,0,2.473-.826,2.641,2.641,0,0,0,.949-2.08q0-2.766-3.375-2.766H4.371ZM20.4-12.5a4.981,4.981,0,0,1,4.008,1.758,6.921,6.921,0,0,1,1.488,4.629,7,7,0,0,1-1.488,4.664A4.967,4.967,0,0,1,20.4.316a4.97,4.97,0,0,1-4.014-1.764A7.018,7.018,0,0,1,14.9-6.117a6.916,6.916,0,0,1,1.488-4.635A4.989,4.989,0,0,1,20.4-12.5Zm0,11.227a3.018,3.018,0,0,0,2.625-1.406,5.9,5.9,0,0,0,.961-3.41,5.923,5.923,0,0,0-.949-3.469A3.038,3.038,0,0,0,20.4-10.922,3.032,3.032,0,0,0,17.761-9.58a5.96,5.96,0,0,0-.937,3.486,5.932,5.932,0,0,0,.949,3.428A3.009,3.009,0,0,0,20.4-1.277Zm17.89.867a8.347,8.347,0,0,1-3.5.727,6.147,6.147,0,0,1-4.6-1.752,6.368,6.368,0,0,1-1.717-4.658A6.344,6.344,0,0,1,30.2-10.752,6.1,6.1,0,0,1,34.737-12.5a9.616,9.616,0,0,1,3.5.645l-.48,1.512a9.3,9.3,0,0,0-3-.574,4.093,4.093,0,0,0-3.193,1.3,5.058,5.058,0,0,0-1.178,3.527,5.011,5.011,0,0,0,1.219,3.428,4.026,4.026,0,0,0,3.176,1.389,9.286,9.286,0,0,0,3.188-.6ZM51.537,0H49.709V-7.828a4.151,4.151,0,0,0-.521-2.361,1.869,1.869,0,0,0-1.635-.732q-1.676,0-3.6,2.086V0H42.127V-16.535h1.828v6.117A5.717,5.717,0,0,1,48.1-12.5q3.434,0,3.434,4.148ZM65.1-6.047H56.723a4.951,4.951,0,0,0,1.2,3.422,3.8,3.8,0,0,0,2.947,1.348,10.7,10.7,0,0,0,3.434-.6L64.622-.41a9.134,9.134,0,0,1-3.773.727A5.775,5.775,0,0,1,56.466-1.43,6.546,6.546,0,0,1,54.8-6.141,6.842,6.842,0,0,1,56.3-10.775,4.868,4.868,0,0,1,60.157-12.5,4.515,4.515,0,0,1,63.684-10.9,6.226,6.226,0,0,1,65.1-6.621ZM63.11-7.535a3.446,3.446,0,0,0-.891-2.408,2.651,2.651,0,0,0-1.992-.979,3.175,3.175,0,0,0-2.35.938,3.71,3.71,0,0,0-1.037,2.449Z"
          transform="translate(0 22)"
          fill="#007ad3"
        />
      </g>
    </svg>
  );
}

export default RocheIcon;
